// extracted by mini-css-extract-plugin
module.exports = {"container":"cart-items_container__DgNiS","finalized":"cart-items_finalized__6dSPK"};